<template>
  <div>
    <form-accordion :title="$t('common.formsSubTitle.gnrl')" :isTitleUpperCase="false">
      <div class="">
        <!-- <div class="form-group d-flex justify-content-between">
          <label class="col-form-label">{{ $t('settings.rcv_rqst_to_pay_eml') }}</label>
          <label class="label-switch">
            <input type="checkbox" class="checkboxSendPaymentsRequestEmail" @change="switchSendPaymentsRequestEmail" :disabled="canSwitchSendEmail()" :checked="settings.sendPaymentRequestEmail === '1'" v-bind:value="settings.sendPaymentRequestEmail">
            <div class="checkbox"></div>
          </label>
        </div> -->
        <!-- <div class="form-group d-flex justify-content-between">
          <label class="col-form-label">{{ $t('settings.ngttn_as_dflt') }}</label>
          <label class="label-switch">
            <input type="checkbox" class="checkboxDefaultNegotiationAllowed" @change="changeSwitchDefaultNegotiationAllowed" :disabled="canSwitchDefaultNegotiation()" :checked="settings.defaultNegotiationAllowed === '1'" v-bind:value="settings.defaultNegotiationAllowed">
            <div class="checkbox"></div>
          </label>
        </div> -->
        <!-- <div class="form-group d-flex justify-content-between">
          <label class="col-form-label">{{ $t('settings.activate_OCR') }}</label>
          <label class="label-switch">
            <input type="checkbox" class="checkboxOcrActivation" @change="changeSwitchOcrActivation" :disabled="canSwitchOcrActivation()" :checked="settings.ocrActivation === '1'" v-bind:value="settings.ocrActivation" >
            <div class="checkbox"></div>
          </label>
        </div> -->
        <!-- <div class="form-group d-flex justify-content-between">
          <label class="col-form-label">{{ $t('settings.gnrt_bnk_trnsfr_ordr')}}</label>
            <label class="label-switch">
              <input type="checkbox" class="checkboxIsToGenerateXML" @change="changeSwitchIsToGenerateXML" :disabled="canSwitchGeneratePain()" :checked="settings.isToGenerateXML === '1'" v-bind:value="settings.isToGenerateXML">
              <div class="checkbox"></div>
            </label>
        </div> -->
        <div class="form-group">
          <form-write-group-label-input inputType="number"
            :colInputSize="0" :colLabelSize="0" inputClass="justify-content-end" horizontal isNotZero
            :minValue="0"
            :inputLabel="$t('administration.rtp_time_before_expiration')"
            v-model="settings.rtpsTimeBeforeExpiration"
            @blur="changeTimeBeforeExpSRTP">
          </form-write-group-label-input>
        </div>
        <div class="form-group">
          <form-write-group-label-input v-if="canSeeSRTP" inputType="number" :maxLength="21"
            :colInputSize="0" :colLabelSize="0" inputClass="justify-content-end" horizontal
            :inputLabel="$t('settings.srtp_max_amnt_lng')"
            v-model="settings.SRTPmaxAmount"
            @blur="changeMaxAmountSRTP">
          </form-write-group-label-input>
        </div>
        <div class="form-group">
          <form-write-group-label-input v-if="canSeeHRTP" inputType="number" :maxLength="21"
            :colInputSize="0" :colLabelSize="0" inputClass="justify-content-end" horizontal
            :inputLabel="$t('settings.hrtp_max_amnt_lng')"
            v-model="settings.HRTPmaxAmount"
            @blur="changeMaxAmountHRTP">
          </form-write-group-label-input>
        </div>
      </div>
    </form-accordion>

    <!-- <hr> -->


    <!-- <form-accordion :title="$t('common.formsSubTitle.pymnt_mthd')" :isTitleUpperCase="false">
      <div class="">
        <div class="form-group row">
          <div class="form-group col-sm-auto">
            <div class="custom-control custom-radio custom-control-inline">
              <input class="custom-control-input" id="defaultInline1" type="radio" name="methodRadio" value="application" :disabled="canSwitchPaymentMethod()" v-model="settings.paymentMethod">
              <label class="custom-control-label" for="defaultInline1" :disabled="canSwitchPaymentMethod()">{{ $t('settings.crdt_trnsfr') }}</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input class="custom-control-input" id="defaultInline2" type="radio" name="methodRadio" value="bankCard" :disabled="canSwitchPaymentMethod()" v-model="settings.paymentMethod">
              <label class="custom-control-label" for="defaultInline2" :disabled="canSwitchPaymentMethod()">{{ $t('settings.bnk_crd') }}</label>
            </div>
          </div>
        </div>
      </div>
    </form-accordion> -->


    <!-- <hr> -->

    <!-- <form-accordion :title="$t('common.formsSubTitle.ngttn')" :isTitleUpperCase="false">
      <div class="">
        <div class="form-group d-flex justify-content-between margin-inline-initial">
          <label class="col-form-label">{{ $t('settings.actvt_ngttn') }}</label>
          <label class="label-switch" >
            <input type="checkbox" class="checkboxNegotiationActivated" v-b-toggle="'collapse-2'" :checked="settings.negotiationActivated" @change="switchNegotiationActivated" :disabled="canSwitchNegociation()" v-bind:value="settings.negotiationActivated">
            <div class="checkbox"></div>
          </label>
        </div>
        <div class="form-group">
          <b-collapse :visible="settings.negotiationActivated === '1'" id="collapse-2" class="mt-2">
            <div class="form-group row">
              <div class="col-md-4">
                <label class="col-form-label">{{ $t('settings.ngttn_thrshld') }}</label>
              </div>
              <div class="col-sm-auto">
                <input class="form-control" type="number" onkeydown="return event.keyCode !== 69" placeholder="Negotiation threshold" value="">
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label class="col-form-label">{{ $t('common.installment_number') }}</label>
              </div>
              <div class="col-md-auto">
                <select class="installmentSelect button-setting" v-model="settings.defaultInstallmentNumber">
                  <option v-for="n in 6"  :min="2" :value="n">{{n}}</option>
                </select>
              </div>
            </div>
          </b-collapse>
        </div>
      </div>
    </form-accordion> -->
  </div>
</template>

<script>
import FormAccordion from "@/components/common/FormAccordion.vue"
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import _ from 'lodash'

export default {
  components: {
    "form-accordion": FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  props: ["settings"],
  data() {
    return {};
  },
  computed: {
    canSeeSRTP () {
      if (this.$engine.user.getUserNorm()) {
        return this.$engine.user.getUserNorm() === '1' && this.$engine.rights.rightIs('rtp_norm_srtp', true)
      } else {
        return this.$engine.rights.rightIs('rtp_norm_srtp', true)
      }
    },
    canSeeHRTP () {
      if (this.$engine.user.getUserNorm()) {
        return this.$engine.user.getUserNorm() === '2' && this.$engine.rights.rightIs('rtp_norm_hrtp', true)
      } else {
        return this.$engine.rights.rightIs('rtp_norm_hrtp', true)
      }
    },
    canSeePSD2 () {
      if (this.$engine.user.getUserNorm()) {
        return this.$engine.user.getUserNorm() === '3' && this.$engine.rights.rightIs('rtp_norm_psd2', true)
      } else {
        return this.$engine.rights.rightIs('rtp_norm_psd2', true)
      }
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    canSwitchNegociation() {
      return this.$engine.rights.rightIs(
        "rtp_settings_unit_nego_allowed",
        false
      );
    },
    changeMaxAmountHRTP() {
      if(this.settings.HRTPmaxAmount) {
        if (this.settings.HRTPmaxAmount.includes('e')) {
          this.settings.HRTPmaxAmount = parseFloat(this.settings.HRTPmaxAmount.split('e')[0]) * Math.pow(10, parseInt(this.settings.HRTPmaxAmount.split('e')[1]))
        }
        if(this.settings.HRTPmaxAmount.length > 16) {
          let partAfterVirgule = parseFloat('.' + this.settings.HRTPmaxAmount.slice(this.settings.HRTPmaxAmount.indexOf('.') + 1)).toFixed(2)
          partAfterVirgule = partAfterVirgule.substring(1)
          let partBeforeVirgule = this.settings.HRTPmaxAmount.split('.')[0]
          this.settings.HRTPmaxAmount = partBeforeVirgule + partAfterVirgule
        } else {
          this.settings.HRTPmaxAmount = parseFloat(this.settings.HRTPmaxAmount).toFixed(2).toString()
        }
      } else {
        return
      }
    },
    changeMaxAmountSRTP() {
      if(this.settings.SRTPmaxAmount) {
        if (this.settings.SRTPmaxAmount.includes('e')) {
          this.settings.SRTPmaxAmount = parseFloat(this.settings.SRTPmaxAmount.split('e')[0]) * Math.pow(10, parseInt(this.settings.SRTPmaxAmount.split('e')[1]))
        }
        if(this.settings.SRTPmaxAmount.length > 16) {
          let partAfterVirgule = parseFloat('.' + this.settings.SRTPmaxAmount.slice(this.settings.SRTPmaxAmount.indexOf('.') + 1)).toFixed(2)
          partAfterVirgule = partAfterVirgule.substring(1)
          let partBeforeVirgule = this.settings.SRTPmaxAmount.split('.')[0]
          this.settings.SRTPmaxAmount = partBeforeVirgule + partAfterVirgule
        } else {
          this.settings.SRTPmaxAmount = parseFloat(this.settings.SRTPmaxAmount).toFixed(2).toString()
        }
      } else {
        return
      }
    },
    changeTimeBeforeExpSRTP() {
      if(this.settings.rtpsTimeBeforeExpiration) {
        this.settings.rtpsTimeBeforeExpiration = parseInt(this.settings.rtpsTimeBeforeExpiration, 10).toString()
      } else {
        return
      }
    },
    switchNegotiationActivated(event) {
      this.negotiationActivated = event.target.checked;
      if (this.negotiationActivated) {
        this.Dom7(event.target)
          .parent()
          .parent()
          .parent()
          .parent()
          .parent()
          .parent()
          .next()
          .addClass("accordion-item-expanded");
      } else {
        this.Dom7(event.target)
          .parent()
          .parent()
          .parent()
          .parent()
          .parent()
          .parent()
          .next()
          .removeClass("accordion-item-expanded");
      }
    },
    canSwitchValidationThreshold() {
      return this.$engine.rights.rightIs(
        "rtp_settings_unit_validation_threshold",
        false
      );
    },
    canSwitchSendEmail() {
      return this.$engine.rights.rightIs("rtp_settings_unit_send_email", false);
    },
    switchSendPaymentsRequestEmail(obj) {
      this.settings.sendPaymentRequestEmail = obj.target.checked;
    },
    canSwitchDefaultNegotiation() {
      return this.$engine.rights.rightIs(
        "rtp_settings_unit_nego_allowed",
        false
      );
    },
    changeSwitchDefaultNegotiationAllowed(obj) {
      this.settings.defaultNegotiationAllowed = obj.target.checked;
    },
    canSwitchOcrActivation() {
      return this.$engine.rights.rightIs(
        "rtp_settings_unit_ocr_activation",
        false
      );
    },
    changeSwitchOcrActivation(obj) {
      this.settings.ocrActivation = obj.target.checked;
    },
    canSwitchGeneratePain() {
      return this.$engine.rights.rightIs(
        "rtp_settings_unit_generate_pain",
        false
      );
    },
    changeSwitchIsToGenerateXML(obj) {
      this.settings.isToGenerateXML = obj.target.checked;
    },
    canSwitchPaymentMethod() {
      return this.$engine.rights.rightIs(
        "rtp_settings_unit_payment_method",
        false
      );
    },
  },
};
</script>


